import React, { useState, useEffect } from 'react';
import styles from './Gallery.module.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

// List of image imports with lowercase extensions
import photo2 from '../../assets/images/MobDramaImage (2).webp';
import photo3 from '../../assets/images/MobDramaImage (3).webp';
import photo4 from '../../assets/images/MobDramaImage (4).webp';
import photo5 from '../../assets/images/MobDramaImage (5).webp';
import photo6 from '../../assets/images/MobDramaImage (6).webp';
import photo8 from '../../assets/images/MobDramaImage (8).webp';
import photo9 from '../../assets/images/MobDramaImage (9).webp';
import photo10 from '../../assets/images/MobDramaImage (10).webp';
import photo11 from '../../assets/images/MobDramaImage (11).webp';
import photo12 from '../../assets/images/MobDramaImage (12).webp';
import photo13 from '../../assets/images/MobDramaImage (13).webp';
import photo14 from '../../assets/images/MobDramaImage (14).webp';
import photo15 from '../../assets/images/MobDramaImage (15).webp';
import photo16 from '../../assets/images/MobDramaImage (16).webp';
import photo17 from '../../assets/images/MobDramaImage (17).webp';
import photo18 from '../../assets/images/MobDramaImage (18).webp';
import photo19 from '../../assets/images/MobDramaImage (19).webp';
import photo20 from '../../assets/images/MobDramaImage (20).webp';
import photo21 from '../../assets/images/MobDramaImage (21).webp';
import photo22 from '../../assets/images/MobDramaImage (22).webp';
import photo23 from '../../assets/images/MobDramaImage (23).webp';
import photo24 from '../../assets/images/MobDramaImage (24).webp';
import photo25 from '../../assets/images/MobDramaImage (25).webp';
import photo26 from '../../assets/images/MobDramaImage (26).webp';
import photo27 from '../../assets/images/MobDramaImage (27).webp';
import photo28 from '../../assets/images/MobDramaImage (28).webp';
import photo29 from '../../assets/images/MobDramaImage (29).webp';
import photo30 from '../../assets/images/MobDramaImage (30).webp';
import photo31 from '../../assets/images/MobDramaImage (31).webp';
import photo32 from '../../assets/images/MobDramaImage (32).webp';
import photo33 from '../../assets/images/MobDramaImage (33).webp';
import photo34 from '../../assets/images/MobDramaImage (34).webp';
import photo35 from '../../assets/images/MobDramaImage (35).webp';
import photo36 from '../../assets/images/MobDramaImage (36).webp';
import photo37 from '../../assets/images/MobDramaImage (37).webp';
import photo38 from '../../assets/images/MobDramaImage (38).webp';
import photo39 from '../../assets/images/MobDramaImage (39).webp';

const allPhotos = [
    photo2, photo3, photo4, photo5, photo6, photo8, photo9, photo10,
    photo11, photo12, photo13, photo14, photo15, photo16, photo17, photo18, photo19, photo20,
    photo21, photo22, photo23, photo24, photo25, photo26, photo27, photo28, photo29, photo30,
    photo31, photo32, photo33, photo34, photo35, photo36, photo37, photo38, photo39
];

const Gallery: React.FC = () => {
    const [photos, setPhotos] = useState<string[]>([]);

    useEffect(() => {
        const initialPhotos = allPhotos.slice(-10);  // Start with the last 10 photos
        setPhotos(initialPhotos);

        const displayedPhotos = new Set(initialPhotos);

        const interval = setInterval(() => {
            setPhotos(prevPhotos => {
                const newPhotos = [...prevPhotos];
                const lastPhoto = newPhotos.pop();  // Remove the last photo

                if (lastPhoto) {
                    displayedPhotos.delete(lastPhoto);
                }

                let availablePhotos = allPhotos.filter(photo => !displayedPhotos.has(photo));

                if (availablePhotos.length === 0) {
                    availablePhotos = allPhotos.filter(photo => !newPhotos.includes(photo));
                    displayedPhotos.clear();
                    newPhotos.forEach(photo => displayedPhotos.add(photo));
                }

                const nextPhoto = availablePhotos[Math.floor(Math.random() * availablePhotos.length)];
                newPhotos.unshift(nextPhoto);  // Add a new random photo at the beginning
                displayedPhotos.add(nextPhoto);

                return newPhotos;
            });
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.gallery}>
            <h1>Gallery</h1>
            <p>This is the gallery page where you can find photos and other media.</p>
            <div className={styles.photoGrid}>
                {photos.map((photo, index) => (
                    <div key={index} className={`${styles.photoItem} ${styles.waveEffect}`}>
                        <LazyLoadImage
                            src={photo}
                            alt={`Gallery item ${index + 1}`}
                            effect="blur"
                            className={styles.photo}
                            width="300"
                            height="300"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Gallery;
